/*
  Hygeon — forces Horizon's own <overflow-list> (used by
  blocks/filters.liquid for the horizontal collection/search filter bar)
  to always show every filter pill instead of collapsing them all behind
  its "Mehr" button.

  Real bug found 2026-09-07 while restyling the filter bar as rounded
  pills (assets/base.css, "HYGEON — collection/search filter bar
  restyled..."): the bar's real container width was capped by a
  max-width:60% computed style whose authored source couldn't be found
  even after a full recursive scan of every stylesheet (including
  inside every @media/@container/@supports block) — fixed with an
  !important override in base.css, confirmed via getBoundingClientRect
  that the container really does grow to its full width once that CSS
  loads. But <overflow-list> (assets/overflow-list.js, a real Shopify/
  Horizon web component) still moves items into its hidden "overflow"
  slot (by setting slot="overflow" on each light-DOM child) based on
  its own internal measurement, and does this again every time Horizon
  re-renders the filter bar via an AJAX update (every filter click,
  sort change, or pagination action) — not just once on first paint.

  First fix attempt (calling the component's own real `.showAll()`
  method — confirmed via direct method inspection this exists and does
  correctly clear every child's slot attribute) worked for a fresh page
  load but NOT for a live filter click: confirmed live that even
  several retried `.showAll()` calls spread across the following
  second all still ended with every child's slot reset back to
  "overflow" — meaning the component keeps re-asserting its own
  collapsed decision on some ongoing basis after an AJAX update, not
  just once at a knowable moment `.showAll()` could out-run.

  Real, working fix: instead of guessing when to call `.showAll()`,
  directly watch each item's own `slot` attribute with a
  MutationObserver and immediately clear it back every single time the
  component sets it to "overflow" — this wins regardless of how many
  times or how late the component re-asserts its decision, since it
  reacts to the exact change being undone rather than to a fixed delay.
  Also intentionally applied on every viewport, not just desktop: on
  mobile this whole horizontal bar sits hidden behind Horizon's own
  separate "Filtern" toggle (a different button/element entirely, see
  the .facets-toggle markup in blocks/filters.liquid) which opens the
  real filters drawer instead — so forcing every pill visible here has
  no visible effect there. Combined with the flex-wrap:wrap rule added
  in base.css, this also means the bar wraps to a second/third row on
  narrower widths rather than ever hiding a filter behind "Mehr" —
  matching the always-fully-visible pill row from the reference
  screenshot (hygi.de) that prompted this restyle.
*/
(function () {
  function clearOverflowSlot(el) {
    if (el.getAttribute('slot') === 'overflow') {
      el.removeAttribute('slot');
    }
  }

  function watchList(listEl) {
    if (listEl.hygeonFiltersFixWatched) return;
    listEl.hygeonFiltersFixWatched = true;

    Array.from(listEl.children).forEach(function (child) {
      if (child.tagName !== 'TEMPLATE') clearOverflowSlot(child);
    });

    var attrObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'slot') {
          clearOverflowSlot(mutation.target);
        }
      });
    });
    attrObserver.observe(listEl, {
      attributes: true,
      attributeFilter: ['slot'],
      subtree: true,
    });

    if (typeof listEl.showAll === 'function') {
      listEl.showAll();
    }
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('overflow-list.facets__overflow-list').forEach(watchList);
  }

  function start() {
    scan(document);

    var domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('overflow-list.facets__overflow-list')) {
            watchList(node);
          }
          scan(node);
        });
      });
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (customElements.get('overflow-list')) {
    start();
  } else {
    customElements.whenDefined('overflow-list').then(start);
  }
})();
